import * as React from 'react';

import classNames from 'classnames';

import { Spinner } from '@base/components/ui/Spinner';

import { IPreloaderScreenProps } from './types';

import * as s from './PreloaderScreen.scss';

export const PreloaderScreen = (props: IPreloaderScreenProps) => {
	const {
		className,
	} = props;

	return <div className={classNames(s.block, className)}>
		<Spinner className={s.spinner}/>
	</div>;
};
